let fastBaseUrl = '';
let joinId = '';

if (process.env.NODE_ENV === 'development') {
    // fastBaseUrl = 'http://fast.mrcargo.com/app-api/'; //线上 kgtest 987321专线产品列表
    // fastBaseUrl = 'http://114.67.124.186:8081/app-api/'; //线上 kgtest 987321专线产品列表
    // baseUrl = "http://114.67.68.72:8082/app-api/" //测试 18721858272  123456 京东云空运运力时效看板
    // fastBaseUrl = "http://192.168.1.117:8084/app-api/" //测试 18721858272  123456 本地
    // fastBaseUrl = "http://114.67.124.186:8081/app-api/";//测试 18721858272  123456 本地
    fastBaseUrl = 'http://192.168.1.127:8080/app-api/'; //曹
    // baseUrl = 'http://192.168.1.125/'; //孙
    joinId = 'a9164216c9054ec59289b7a29237e79b';
} else {
    // 线上322323
    fastBaseUrl = 'https://fast.mrcargo.com/app-api/';
    // baseUrl = "http://114.67.68.72:8082/app-api/" //线上测试环境
    joinId = '';
}

export {
    fastBaseUrl,
    joinId,
}
